import { connect } from 'react-redux'
import { getLightbox } from '../selectors'
import { setLightbox } from '../actions'
import Lightbox from '../components/lightbox'

const mapStateToProps = state => ({
  elements: getLightbox(state),
})

const mapDispatchToProps = dispatch => ({
  closeLightbox: () => dispatch(setLightbox('')),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Lightbox)



// WEBPACK FOOTER //
// ./src/modules/core/containers/lightbox.js